import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import SocialIcon, { ISimplifiedSocialButtonProps } from '@gik/ui/SocialIcon/SocialIcon';

const blockName = 'text-message-icon';

export default function TextMessageIcon({ className, ...otherProps }: ISimplifiedSocialButtonProps) {
  const bem = bemBlock(blockName);

  return (
    <SocialIcon
      className={bem(null, null, [className])}
      icon={{
        set: 'hero-icons',
        name: 'ChatAltOutline',
      }}
      {...otherProps}
    />
  );
}
